module.exports = __webpack_public_path__ + "static/geekwire_logo-8bb93fb4da0292581051b126c1ebd206.svg";